import { StyleSheet } from '@react-pdf/renderer';

const styles = {
  container: {
    width: '100%',
    maxWidth: 1100,
    margin: '0 auto 16px',
    background: '#ffffff',
    borderRadius: 2,
    boxShadow: '0 0px 0px rgba(0,0,0,0.08)',
    border: '1px solid #e5e7eb',
    overflow: 'hidden',
    fontFamily: 'Avenir !important',    
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '24px 24px 16px 24px',
    borderBottom: '1px solid #e5e7eb',
    fontFamily: 'Avenir !important',
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 8,
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  brandMark: {
    width: 36,
    height: 36,
    background: '#165B9D',
    borderRadius: 6,
  },
  titleGroup: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 4,
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
    color: '#111827',
    fontFamily: 'Avenir !important',
  },
  italicSub: {
    fontSize: '16px !important',
    color: '#6b7280',
    fontStyle: 'italic',
    fontFamily: 'Avenir !important',
  },
  subtitle: {
    fontSize: 13,
    color: '#6b7280',
    fontFamily: 'Avenir !important',
  },
  headerRight: {
    alignItems: 'center',
  },
  logo: {
    fontWeight: 700,
    fontSize: 24,
    color: '#111827',
    fontFamily: 'Avenir !important',
  },
  dateBadge: {
    background: '#111827',
    color: '#ffffff',
    fontSize: 12,
    fontWeight: 700,
    px: 32,
    py: 4,
    fontFamily: 'Avenir !important',
  },
  body: {
    padding: '16px 24px',
  },
  gridMd: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 24,
  },
  gridBorderedSection: {
    marginTop: 12,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 24,
    padding: '24px 0'
  },
  twoCol: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: 24,
  },
  pieSection: {
    background: '#fdfdfd',
    border: '1px solid #e5e7eb',
    borderRadius: 2,
    padding: 16,
  },
  sectionToned: {
    background: '#ffffff',
  },
  sectionHeader: {
    fontWeight: 700,
    letterSpacing: 0.6,
    color: '#374151',
    marginBottom: 2,
    fontFamily: 'Avenir !important',
  },
  text: {
    fontSize: 14,
    color: '#111827',
    lineHeight: 1.6,
    fontFamily: 'Avenir !important',
  },
  bulletList: {
    margin: 0,
    paddingLeft: 18,
    color: '#111827',
    lineHeight: 1.6,
    fontSize: '14px',
    fontFamily: 'Avenir !important',
    '& li': {
      listStyleType: 'disc',
      '&::marker': {
        fontSize: '1.5em', // Makes the bullet 20% larger
        color: '#111827',
      },
    },
  },
  placeholder: {
    height: 180,
    background: 'repeating-linear-gradient(135deg, #e5e7eb, #e5e7eb 8px, #f3f4f6 8px, #f3f4f6 16px)',
    borderRadius: 8,
    border: '1px dashed #cbd5e1',
  },
  kvGroup: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 4,
  },
  kvRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #eceef1',
  },
  kvLabel: {
    color: '#6b7280',
    fontSize: '12px !important',
    fontFamily: 'Avenir !important',
  },
  kvValue: {
    color: '#111827',
    fontSize: '12px !important',
    fontWeight: 500,
    fontFamily: 'Avenir !important',
  },
  top10Box: {
    border: '1px solid #e5e7eb',
    borderRadius: 2,
    padding: 12,
    background: '#fdfdfd',
  },
  top10Columns: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },
  top10Item: {
    padding: '6px 8px',
    color: '#111827',
    fontSize: 13,
    fontWeight: 700,
    fontFamily: 'Avenir !important',
  },
  perfTable: {
    border: '1px solid #e5e7eb',
    borderRadius: 2,
    overflow: 'hidden',
    background: '#fdfdfd',
  },
  perfHeader: {
    display: 'grid',
    gridTemplateColumns: '1.2fr repeat(6, 1fr)',
    background: '#fdfdfd',
    borderBottom: '1px solid #e5e7eb',
  },
  perfRow: {
    display: 'grid',
    gridTemplateColumns: '1.2fr repeat(6, 1fr)',
  },
  perfCell: {
    padding: '6px 4px',
    fontSize: 14,
    fontFamily: 'Avenir !important',
  },
  perfCellHeader: {
    padding: '6px 4px',
    fontSize: 12,
    fontWeight: 700,
    fontFamily: 'Avenir !important',
  },
  perfPositive: {
  },
  perfCellTimeline: {
    flex: 2,
    padding: '6px 4px',
    fontSize: 14,
    textAlign: 'left',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    fontFamily: 'Avenir !important',
  },
  perfCellHeaderTimeline: {
    flex: 2,
    padding: '6px 4px',
    fontSize: 14,
    textAlign: 'left',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    fontFamily: 'Avenir !important',
  },
  historyChart: {
    border: '1px solid #e5e7eb',
    borderRadius: 2,
    padding: 12,
    background: '#fdfdfd',
  },
  footer: {
    padding: 16,
    borderTop: '1px solid #e5e7eb',
    color: '#6b7280',
    fontSize: 12,
    textAlign: 'center' as const,
    fontFamily: 'Avenir !important',
  },
  fundPartnerSection: {
  },
  fundPartnerItem: {
    marginBottom: 8,
    display: 'flex',
    gap: 16,
  },
  fundPartnerLabel: {
    fontSize: '14px !important',
    fontWeight: 'bold',
    color: '#374151',
    marginBottom: 2,
    fontFamily: 'Avenir !important',
  },
  fundPartnerValue: {
    fontSize: '14px !important',
    color: '#374151',
    fontFamily: 'Avenir !important',
  },
  contactItem: {
    fontSize: '14px !important',
    color: '#374151',
    marginBottom: 4,
    fontFamily: 'Avenir !important',
  },
  fundPartnerContactContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  fundPartnerColumn: {
    width: '48%',
  },
  contactColumn: {
    width: '48%',
  },
  fundPartnerTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#374151',
    marginBottom: 8,
    fontFamily: 'Avenir !important',
  },
  contactTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#374151',
    marginBottom: 8,
    fontFamily: 'Avenir !important',
  },
  fundPartnerContent: {
    flexDirection: 'column',
  },
  fundPartnerRow: {
    marginBottom: 6,
  },
  contactContent: {
    flexDirection: 'column',
  },
  sectionText: {
    fontSize: '12px !important',
    color: '#657381 !important',
    fontFamily: 'Avenir !important',
  }
};

// PDF styles for react-pdf renderer
export const pdfStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    fontFamily: 'Avenir',
  },
  container: {
    width: '100%',
    backgroundColor: '#ffffff',
  },
  avenirMarginAdjust: {  },
  avenirTableMarginAdjust: {  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '16 24 8 24',
    borderBottom: '1px solid #e5e7eb',
  },
  headerLeft: {
    flexDirection: 'column',
    gap: 8,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#111827',
  },
  italicSub: {
    fontSize: 12,
    color: '#6b7280',
    fontStyle: 'italic',
  },
  headerRight: {
    alignItems: 'center',
  },
  logo: {
    color: '#111827',
  },
  dateBadge: {
    backgroundColor: '#111827',
    color: '#ffffff',
    padding: '0 16',
    fontSize: 10,
    fontWeight: 'bold',
  },
  body: {
    padding: '12px 24px 0 24px',
  },
  twoCol: {
    flexDirection: 'row',
    gap: 24,
  },
  leftColumn: {
    flex: 5,
  },
  rightColumn: {
    flex: 3,
  },
  sectionHeader: {
    fontSize: 12,
    fontWeight: 'bold',
    letterSpacing: 0.6,
    color: '#374151',
  },
  bulletList: {
    marginLeft: 0,
    color: '#111827',
    fontSize: 14,
    paddingRight: 10,
  },
  bulletItemContainer: {
    flexDirection: 'row',
    gap: 4,
  },
  bulletItemDot: {
    width: 16,
  },
  bulletItem: {
    fontSize: 10,
    color: '#111827',
  },
  kvGroup: {
    flexDirection: 'column',
    gap: 0,
  },
  kvRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '1px solid #eceef1',
  },
  kvLabel: {
    color: '#6b7280',
    fontSize: 9,
    flex: 1,
    marginRight: 8,
  },
  kvValue: {
    color: '#111827',
    fontSize: 9,
    fontWeight: 500,
    flex: 1,
    textAlign: 'right',
  },
  kvLabelSingleLine: {
    color: '#6b7280',
    fontSize: 9,
    flex: 1,
    marginRight: 8,
  },
  kvValueSingleLine: {
    color: '#111827',
    fontSize: 9,
    fontWeight: 500,
    flex: 1,
    textAlign: 'right',
  },
  kvWidth60: {
    maxWidth: '60%',
  },
  kvWidth40: {
    maxWidth: '40%',
  },
  kvWidth70: {
    maxWidth: '70%',
  },
  kvWidth30: {
    maxWidth: '30%',
  },
  kvWidth80: {
    maxWidth: '80%',
  },
  kvWidth20: {
    maxWidth: '20%',
  },
  top10Box: {
    border: '1px solid #e5e7eb',
    padding: '12px 16px',
    backgroundColor: '#fdfdfd',
    borderRadius: 4,
  },
  top10Grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  top10Item: {
    width: '50%',
    padding: '2 2',
    color: '#111827',
    fontSize: 10,
  },
  perfTable: {
    border: '1px solid #e5e7eb',
    borderRadius: 4,
    backgroundColor: '#fdfdfd',
    padding: '0 8px',
  },
  perfHeader: {
    flexDirection: 'row',
    borderBottom: '1px solid #e5e7eb',
  },
  perfRow: {
    flexDirection: 'row',
  },
  perfCell: {
    flex: 1,
    padding: '4px 4px',
    fontSize: 10,
    color: '#374151',
    textAlign: 'left',
  },
  perfCellHeader: {
    flex: 1,
    padding: '4px 4px',
    fontSize: 10,
    fontWeight: 'bold',
    color: '#374151',
    textAlign: 'left',
  },
  perfCellFirst: {
    flex: 1.2,
    padding: '6px 0',
    fontSize: 10,
    fontWeight: 'bold',
    color: '#374151',
    textAlign: 'left',
  },
  perfCellTimeline: {
    flex: 2,
    padding: '4px 4px',
    fontSize: 10,
    textAlign: 'left',
    flexWrap: 'wrap',
    color: '#374151',
  },
  perfCellHeaderTimeline: {
    flex: 2,
    padding: '4px 4px',
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'left',
    flexWrap: 'wrap',
    color: '#374151',
  },
  perfPositive: {
    color: '#374151',
  },
  section: {
    marginBottom: 8,
  },
  marginBottom12: {
    marginBottom: 12,
  },
  marginBottom6: {
    marginBottom: 6,
  },
  historyChart: {
    backgroundColor: '#fdfdfd',
    border: '1px solid #e5e7eb',
    borderRadius: 4,
    overflow: 'hidden',
    padding: '4px 0'
  },
  allocationCharts: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 32,
    gap: 12,
  },
  allocationChartItem: {
    border: '1px solid #e5e7eb',
    borderRadius: 4,
    padding: 8,
    backgroundColor: '#fdfdfd',
  },
  allocationChartTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#374151',
    marginBottom: 8,
    textAlign: 'center',
  },
  allocationChartContent: {
    flexDirection: 'column',
  },
  allocationChartRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 2,
    borderBottom: '1px solid #f3f4f6',
  },
  allocationChartLabel: {
    fontSize: 10,
    color: '#374151',
    flex: 1,
  },
  allocationChartValue: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#059669',
    textAlign: 'right',
    minWidth: 30,
  },
  borderedSection: {
    padding: '0',
  },
  fundPartnerSection: {
  },
  fundPartnerItem: {
    marginBottom: 8,
  },
  fundPartnerLabel: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#374151',
    marginBottom: 0,
  },
  fundPartnerValue: {
    fontSize: 10,
    color: '#374151',
  },
  contactSection: {
    padding: 8,
  },
  contactItem: {
    fontSize: 10,
    color: '#374151',
    marginBottom: 1,
  },
  fundPartnerContactContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 4,
  },
  fundPartnerColumn: {
    width: '48%',
  },
  contactColumn: {
    width: '48%',
  },
  fundPartnerTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#374151',
    marginBottom: 2,
  },
  contactTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#374151',
    marginBottom: 0,
  },
  fundPartnerContent: {
    flexDirection: 'column',
  },
  fundPartnerRow: {
    marginBottom: 3,
    display: 'flex',
    flexDirection: 'row',
    gap: 4
  },
  contactContent: {
    flexDirection: 'column',
  },
  sectionText: {
    fontSize: '9px',
    color: '#657381',
  },
  footer: {
    padding: 16,
    borderTop: '1px solid #e5e7eb',
    color: '#6b7280',
    fontSize: 12,
    textAlign: 'center',
  },
});

export default styles;


